import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'app-svg-upload',
  standalone: false,
  templateUrl: './svg-file-upload.component.html',
  styleUrl: './svg-file-upload.component.scss',
})
export class SvgUploadComponent implements OnChanges {
  @Input() height: number = 0;
  @Input() width: number = 0;
  @Input() selectedImage: string = '';
  @Input() browseText: string = '';
  @Input() venueImage: boolean = false;
  @Input() showRemove: boolean = false;
  @Input() key: number = 0;
  @Output() fileSelected = new EventEmitter<File | null>();
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef<HTMLInputElement>;

  isDragging = false;
  errorMessage: string | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['key']?.currentValue > 0) {
      this.resetComponent();
    }
  }

  resetComponent(): void {
    this.errorMessage = null;
    this.selectedImage = '';
    this.venueImage = false;
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(): void {
    this.isDragging = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = false;

    if (event.dataTransfer?.files.length) {
      this.onDropFileValidation(event);
    }
  }

  onClickFileValidation(event: Event) {
    const target = event.target as HTMLInputElement;
    const validTypes = ['image/svg+xml'];
    if (target.files?.length) {
      const file = target.files[0];

      if (!validTypes.includes(file.type)) {
        this.errorMessage = 'Only SVG files are allowed.';
        target.value = '';
        return;
      }
      this.onFileSelected(file);
    }
  }

  onDropFileValidation(event: DragEvent) {
    const validTypes = ['image/svg+xml'];

    if (event.dataTransfer?.files.length) {
      const file = event.dataTransfer.files[0];

      if (!validTypes.includes(file.type)) {
        this.errorMessage = 'Only SVG files are allowed.';
        if (this.fileInput) {
          this.fileInput.nativeElement.value = '';
        }
        return;
      }
      this.onFileSelected(file);
    }
  }

  onFileSelected(file: any): void {
    this.errorMessage = null;
    this.loadImagePreview(file); // Load preview if valid
    this.fileSelected.emit(file); // Emit valid file
  }

  private loadImagePreview(file: File): void {
    const reader = new FileReader();
    reader.onload = () => {
      this.selectedImage = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  removeFile(event: MouseEvent) {
    event.stopPropagation();
    this.selectedImage = '';
    this.errorMessage = null;

    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
    this.fileSelected.emit(null);
  }
}